
import { mapGetters } from 'vuex'
import Button from '~/components/buttons/Button'
export default {
  components: { Button },
  props: {
    contentItem: {
      type: Object,
      required: true,
    },
    content: {
      type: Object,
      required: true,
    },
    loyaltyCustomer: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      vxCustomer: 'customer/getCustomer',
    }),
  },
  methods: {
    async isSubscribeNewsletter() {
      if (this.vxCustomer && this.vxCustomer.email) {
        const isSub = await this.$axios
          .post('/api/klaviyo/isSubscribed', {
            email: this.vxCustomer.email,
            locale: this.$i18n.locale,
          })
          .catch((error) => {
            return error
          })
        return isSub.status === 200
      } else {
        return false
      }
    },
  },
}
